<template>
  <div>
    <p class="headline font-weight-medium">Questions</p>
    <app-editor v-model="questions[0].content"></app-editor>
    <p class="headline font-weight-medium">Answers</p>
    <app-editor v-model="questions[0].good_answer"></app-editor>
  </div>
</template>
<script>
import Editor from "@/components/Utils/Editor.vue";
import rulesMixin from "@/mixins/rulesMixin";
import crudMixin from "@/mixins/crudMixin";
import { postQuestions } from "@/api/api";

export default {
  components: {
    appEditor: Editor,
  },
  props: {
    question_group: {
      required: false,
      default: () => {},
      type: Object,
    },
  },
  mixins: [rulesMixin, crudMixin],
  data() {
    return {
      questions: [],
      defaultQuestion: () => ({
        title: "Custom",
        content: {
          type: "doc",
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Write your questions here...",
                },
              ],
            },
          ],
        },
        good_answer: {
          type: "doc",
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Write your answers here...",
                },
              ],
            },
          ],
        },
      }),
    };
  },
  methods: {
    async save(uuid) {
      let questions = JSON.parse(JSON.stringify(this.questions));
      questions.forEach((element) => {
        element.content = JSON.stringify(element.content);
        element.good_answer = JSON.stringify(element.good_answer);
      });
      let question_group = {
        uuid,
        questions,
      };

      const response = await postQuestions(question_group);
      questions = response.questions;
      questions.forEach((element) => {
        element.content = JSON.parse(element.content);
        element.good_answer = JSON.parse(element.good_answer);
      });
      this.questions = questions;
      return response;
    },
  },
  created() {
    if (this.question_group.questions) {
      this.questions = [...this.question_group.questions];
      this.questions.forEach((element) => {
        element.content = JSON.parse(element.content);
        element.good_answer = JSON.parse(element.good_answer);
      });
    } else this.questions.push(this.defaultQuestion());
  },
};
</script>
